<script setup lang="ts">
function onCookieConsent() {
  window.ppms?.cm?.api?.('openConsentForm');
}
</script>

<template>
  <div class="flex flex-col lg:flex-row flex-wrap lg:items-start gap-l xl:gap-2xl py-m pb-24 lg:pb-m">
    <Icon
      name="iad-icon:logo-iad"
      class="size-16 text-secondary"
    />
    <div>
      <div class="flex flex-col lg:flex-row flex-wrap justify-center gap-x-2xl gap-y-s lg:gap-y-l">
        <MainFooterLink
          to="privacy-policy"
          :text="$t(`core.navigation.privacy_policy`)"
          menu-category1="privacy_policy"
        />
        <MainFooterLink
          to="legal-mentions"
          :text="$t(`core.navigation.terms_conditions`)"
          menu-category1="terms_and_conditions"
        />
        <MainFooterLink
          to="accessibility"
          :text="$t(`core.navigation.accessibility`)"
          menu-category1="accessibility_notice"
        />
        <MainFooterLink
          to="cookie-policies"
          :text="$t(`core.navigation.cookie_policy`)"
          menu-category1="cookie_policy"
        />
        <MainFooterLink
          :text="$t(`core.navigation.cookie_configuration`)"
          class="text-start"
          menu-category1="configure_my_cookies"
          @click="onCookieConsent"
        />
      </div>
      <figure class="flex-wrap gap-s items-center pt-2xs hidden lg:flex">
        <img
          loading="lazy"
          class="w-[71px] h-auto"
          alt="unis logo"
          width="216"
          height="101"
          src="~/assets/images/unis-small.jpeg"
        >
        <figcaption v-text="$t(`core.navigation.unis_membership`)" />
      </figure>
    </div>
    <div class="flex flex-wrap gap-s lg:ms-auto">
      <IadBtn
        icon
        size="small"
        variant="outlined"
        target="_blank"
        href="https://www.facebook.com/iadFrance/"
      >
        <Icon name="iad-icon:facebook" />
      </IadBtn>
      <IadBtn
        icon
        size="small"
        variant="outlined"
        target="_blank"
        href="https://www.instagram.com/iadfranceofficiel/?hl=en"
      >
        <Icon name="iad-icon:instagram" />
      </IadBtn>
      <IadBtn
        icon
        size="small"
        variant="outlined"
        target="_blank"
        href="https://www.linkedin.com/company/iadfranceofficiel/"
      >
        <Icon name="iad-icon:linkedin" />
      </IadBtn>
      <IadBtn
        icon
        size="small"
        variant="outlined"
        target="_blank"
        href="https://x.com/IADFrance"
      >
        <Icon name="iad-icon:x-twitter" />
      </IadBtn>
      <IadBtn
        icon
        size="small"
        variant="outlined"
        target="_blank"
        href="https://www.youtube.com/user/IADFrance"
      >
        <Icon name="iad-icon:youtube" />
      </IadBtn>
    </div>
    <figure class="flex flex-wrap gap-s items-center pt-2xs lg:hidden">
      <img
        loading="lazy"
        class="w-[71px] h-auto"
        alt="unis logo"
        width="216"
        height="101"
        src="~/assets/images/unis-small.jpeg"
      >
      <figcaption v-text="$t(`core.navigation.unis_membership`)" />
    </figure>
  </div>
</template>
